import { createReducer } from '@sde/widgets-core/src/redux/helpers/createReducer';
import { GET_PAYERS } from './constants';

const initialState = {
  list: [],
};

export const payersReducer = createReducer(initialState, {
  [`${GET_PAYERS}_SUCCESS`]: (state, action) => {
    return {
      list: action.payload,
    };
  },
});
